import { render, staticRenderFns } from "./salary_all.vue?vue&type=template&id=bf89414c&scoped=true"
import script from "./salary_all.vue?vue&type=script&lang=js"
export * from "./salary_all.vue?vue&type=script&lang=js"
import style0 from "./salary_all.vue?vue&type=style&index=0&id=bf89414c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf89414c",
  null
  
)

export default component.exports